module.exports = __webpack_public_path__ + "img/logoto.20843424.svg";